import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { LocaleContext } from '../../../../../../contexts/LocaleContext'
import axiosService from '../../../../../../utils/AxiosService'
import { toastError } from '../../../../../FormComponents/Toasts'
import YesNoToggle from '../../../../../Shared/YesNoToggle'

export default observer(function PmChecklistReview({ actionDraft, version, heading = 'Checklist' }) {
  const { id, action_id } = useParams()
  const { localeState } = useContext(LocaleContext)

  const mark = (item, status) => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/actions/${action_id}/checklist_items/${item.id}/review`, { status })
      .then(updated => { item.reviewed_status = updated.reviewed_status })
      .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <div className="border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg p-4 w-[650px] mb-4 bg-white dark:bg-rb-dark-mode">
      <p className="font-bold mb-3 dark:text-white">{heading}</p>

      {actionDraft.checklist_items.map(item => {
        const doneByInfluencer = !!version?.isChecked(item.id)

        return (
          <div key={item.id} className="flex items-center justify-between gap-2 py-2 border-b-1 border-rb-widget-border dark:border-rb-dark-mode-lighter last:border-none">
            <label className="flex items-center gap-2 min-w-0" title="Marked done by the influencer">
              <input type="checkbox" checked={doneByInfluencer} disabled readOnly className="text-rb-green rounded-sm shrink-0 cursor-not-allowed" />
              {/* min-w-0 needed for break-words to actually apply inside a flex parent */}
              <span className={`text-sm dark:text-white break-words min-w-0 ${doneByInfluencer ? 'line-through text-rb-mat-grey dark:text-rb-dark-mode-text-grey' : ''}`}>
                {item.text(localeState.locale)}
              </span>
            </label>
            <div className="ml-4 shrink-0">
              <YesNoToggle
                value={item.reviewed_status === 'passed' ? true : item.reviewed_status === 'failed' ? false : null}
                onChange={passed => mark(item, passed ? 'passed' : 'failed')}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
})
